/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionsloaderror2Inputs */

const en_actionsloaderror2 = /** @type {(inputs: Actionsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The actions could not be loaded.`)
};

const de_actionsloaderror2 = /** @type {(inputs: Actionsloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aktionen konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The actions could not be loaded." |
*
* @param {Actionsloaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionsloaderror2 = /** @type {((inputs?: Actionsloaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionsloaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionsloaderror2(inputs)
	return de_actionsloaderror2(inputs)
});
export { actionsloaderror2 as "actionsLoadError" }